import { render, staticRenderFns } from "./OUserDetail.vue?vue&type=template&id=eaeaf966&scoped=true&"
import script from "./OUserDetail.vue?vue&type=script&lang=ts&"
export * from "./OUserDetail.vue?vue&type=script&lang=ts&"
import style0 from "./OUserDetail.vue?vue&type=style&index=0&id=eaeaf966&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaeaf966",
  null
  
)

export default component.exports